import { Observable } from "rxjs";
import { LoginData } from "../model/login-data";
import { UserInfo } from "../model/user-info";
import { AuthenticationConfig } from "../model/authentication-config";

export abstract class AuthenticationService {
    public abstract login(data: LoginData): Observable<UserInfo>;
    public abstract isAuthenticated(): Observable<boolean>;
    public abstract logout(): Observable<void>;
    public abstract authenticationConfig: AuthenticationConfig | undefined;
}
